/* Owned Ladi enhancements. Commerce stays in Dawn product-info/product-form/cart. */
(() => {
  const controllers = new WeakMap();
  function setup(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    controllers.set(root, controller);
    const on = (node, event, fn) => node?.addEventListener(event, fn, { signal: controller.signal });
    let opened, returnTo;
    function close() {
      if (!opened) return;
      opened.querySelectorAll('video').forEach(video => video.pause());
      opened.hidden = true;
      opened.querySelector('[data-ladi-aura-c07-stage]')?.replaceChildren();
      opened = null;
      document.documentElement.classList.remove('ladi-aura-modal-open');
      removeTrapFocus(returnTo?.isConnected ? returnTo : undefined);
    }
    controller.signal.addEventListener('abort', close, { once: true });
    on(root, 'click', event => {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.matches('[data-ladi-aura-c04-close], [data-ladi-aura-c07-close]')) return close();
      if (button.matches('[data-ladi-aura-c04-open], [data-ladi-aura-c07-open]')) {
        const modal = document.getElementById(button.getAttribute('aria-controls'));
        if (!modal) return;
        close();
        const template = button.closest('[data-ladi-aura-c07-card]')?.querySelector('template');
        if (template) modal.querySelector('[data-ladi-aura-c07-stage]').replaceChildren(template.content.cloneNode(true));
        returnTo = button;
        opened = modal;
        modal.hidden = false;
        document.documentElement.classList.add('ladi-aura-modal-open');
        const dialog = modal.querySelector('[role="dialog"]');
        trapFocus(dialog, dialog.querySelector('button'));
      }
      if (button.matches('[data-ladi-aura-faq-trigger]')) {
        const item = button.closest('[data-ladi-aura-faq-item]');
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        item.dataset.open = String(expanded);
        item.classList.toggle('is-open', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        item.querySelector('[data-ladi-aura-faq-panel]').hidden = !expanded;
      }
      const rail = button.closest('[data-ladi-aura-c07-root], [data-ladi-aura-c08-root]');
      if (rail && button.matches('[data-ladi-aura-c07-prev], [data-ladi-aura-c07-next], [data-ladi-aura-c07-dot], [data-ladi-aura-c08-prev], [data-ladi-aura-c08-next], [data-ladi-aura-c08-dot]')) {
        const viewport = rail.querySelector('[data-ladi-aura-c07-viewport], [data-ladi-aura-c08-viewport]');
        if (!viewport) return;
        const cards = [...viewport.querySelectorAll('[data-ladi-aura-c07-card], [data-ladi-aura-c08-card]')];
        let index = cards.findIndex(card => card.getBoundingClientRect().right > viewport.getBoundingClientRect().left + viewport.clientWidth / 2);
        index = button.hasAttribute('data-index') ? Number(button.dataset.index) : index + (button.hasAttribute('data-ladi-aura-c07-prev') || button.hasAttribute('data-ladi-aura-c08-prev') ? -1 : 1);
        cards[Math.max(0, Math.min(cards.length - 1, index))]?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    });
    on(root, 'keydown', event => { if (event.key === 'Escape' && opened) { event.stopPropagation(); close(); } });
    const railViewport = root.querySelector('[data-ladi-aura-c07-viewport], [data-ladi-aura-c08-viewport]');
    if (railViewport) {
      const syncRail = () => {
        const cards = [...railViewport.querySelectorAll('[data-ladi-aura-c07-card], [data-ladi-aura-c08-card]')];
        const left = railViewport.getBoundingClientRect().left;
        let index = 0;
        cards.forEach((card, i) => { if (Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[index].getBoundingClientRect().left - left)) index = i; });
        root.querySelectorAll('[data-ladi-aura-c07-dot], [data-ladi-aura-c08-dot]').forEach((dot, i) => {
          dot.setAttribute('aria-current', String(i === index));
          dot.classList.toggle('is-active', i === index);
        });
      };
      on(railViewport, 'scroll', syncRail);
      syncRail();
    }

  }
  const init = scope => scope.querySelectorAll('[data-ladi-aura-c04-root], [data-ladi-aura-c07-root], [data-ladi-aura-c08-root], [data-ladi-aura-faq-root]').forEach(setup);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-section-id]').forEach(root => { controllers.get(root)?.abort(); controllers.delete(root); }));

  class LadiSticky extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.productInfo);
      if (!this.root) return;
      this.abort = new AbortController();
      this.button = this.querySelector('[data-sticky-submit]');
      this.summary = this.querySelector('[data-sticky-summary]');
      this.sync = () => {
        const form = this.root.querySelector('product-form form');
        const submit = form?.querySelector('[name="add"]');
        const quantity = this.root.querySelector('quantity-input input');
        const variant = this.root.querySelector('variant-selects [data-selected-variant]');
        let title = '';
        try { title = JSON.parse(variant?.textContent || '{}').title || ''; } catch { /* native state may be replacing */ }
        const price = this.root.querySelector('.price:not(.hidden) .price-item--regular')?.textContent.trim() || '';
        this.summary.textContent = `${title} · ${price} · Qty ${quantity?.value || 1}`;
        this.button.disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        this.button.textContent = submit?.querySelector('span')?.textContent.trim() || 'Select a size';
        const bounds = submit?.getBoundingClientRect();
        this.hidden = !bounds || bounds.bottom > 0;
      };
      this.button.addEventListener('click', () => {
        const form = this.root.querySelector('product-form form');
        const submit = form?.querySelector('[name="add"]');
        if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        this.button.disabled = true;
        form.requestSubmit(submit);
      }, { signal: this.abort.signal });
      this.observer = new MutationObserver(records => { if (records.some(record => !this.contains(record.target))) this.sync(); });
      this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, characterData: true });
      this.root.addEventListener('change', this.sync, { signal: this.abort.signal });
      window.addEventListener('scroll', this.sync, { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', this.sync, { signal: this.abort.signal });
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  }
  if (!customElements.get('ladi-sticky')) customElements.define('ladi-sticky', LadiSticky);
})();
